/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconButton, TableCell, TableRow } from '@material-ui/core'
import { withStyles, Theme, createStyles } from '@material-ui/core/styles'
import MoreIcon from '@material-ui/icons/MoreVert'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/WalletListTableRowDesktop.Skeleton.styles'

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#a5a5a5',
      color: theme.palette.common.white
    },
    body: {
      fontSize: 14
    }
  })
)(TableCell)

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      gridTemplateColumns: '2fr 2fr 2fr 2fr 2fr 2fr 2fr 1fr',
      // [theme.breakpoints.between(960, 1380)]: {
      //   gridTemplateColumns:
      //     'minmax(7%, 8%) minmax(12%, 13%) minmax(12%, 13%) minmax(15%, 16%) minmax(14%, 14%) minmax(11%, 11%) minmax(9%, 10%) minmax(17%, 18%) minmax(14%, 15%) minmax(12%, 13%) minmax(15%, 18%) minmax(8%, 12%)'
      // },
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow)

export const WalletTransactionListRowDesktopSkeleton = () => {
  const classes = useStyles()

  return (
    <StyledTableRow>
      <StyledTableCell component="th" scope="row">
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell component="th" scope="row">
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="right">
        {' '}
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="right">
        {' '}
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="right">
        {' '}
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="right">
        {' '}
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="right">
        {' '}
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <div />
    </StyledTableRow>
  )
}
